export default __webpack_public_path__ + "static/media/karyali.623a563c.jpg";